import PropTypes from 'prop-types';
import React from 'react';
import { Link } from 'react-router-dom';
import Moment from 'moment';
import Datetime from 'react-datetime';
import { OverlayTrigger, Tooltip } from 'react-bootstrap';
import { Dropdown } from '../../components/Dropdown/Dropdown';
import { AppSettings } from '../../constants';

var yesterday = Moment().subtract(1, "day");
var isValidAppointmentDate = function (current) {
  return current.isAfter(yesterday);
};
const OverlayReason = ({ ...props }) => {
  const { reason } = props;

  return (
    <OverlayTrigger
      placement='bottom'
      overlay={toolTipReason(reason)}
      delayHide={10}
      delayShow={500}
    >
      <strong
        className='text-danger'
        style={{
          fontSize: 14,
          display: 'inline-block',
          marginLeft: 10,
          borderBottom: '1px dashed',
          lineHeight: '18px',
          cursor: 'default'
        }}
      >
        Reason
      </strong>
    </OverlayTrigger>
  );
};

OverlayReason.propTypes = {
  reason: PropTypes.string
};

const toolTipReason = reason => {
  return (
    <Tooltip className='in tooltip-siteone' id='wo-info-tooltip-reason'>
      <span>{reason}</span>
    </Tooltip>
  );
};

class WorkOrderInfo extends React.Component {
  static propTypes = {
    history: PropTypes.object,
    location: PropTypes.object,
    woInformation: PropTypes.object,
    isEditResolved: PropTypes.bool,
    isEditAppointment: PropTypes.bool,
    isEditClosed: PropTypes.bool,
    isEditReOpen: PropTypes.bool,
    handleModeClosed: PropTypes.func,
    handleModeResolved: PropTypes.func,
    handleModeReOpen: PropTypes.func,
    handleModeOpenSubcontractor: PropTypes.func,
    handleSaveEditClosed: PropTypes.func,
    handleSaveEditAppointment: PropTypes.func,
    handleSaveEditResolved: PropTypes.func,
    handleSaveEditReOpen: PropTypes.func,
    onResendNotice: PropTypes.func,
    SubcontractorList: PropTypes.array,
    UserList: PropTypes.array,
    fetchSubcontractor: PropTypes.func,
    fetchUser: PropTypes.func,
    isFetchedSubcontractor: PropTypes.bool,
    isFetchedUser: PropTypes.bool,
    requestDetail: PropTypes.object,
    bindingWorkOrderHistory: PropTypes.func,
    sso: PropTypes.bool,
    isPunchItem: PropTypes.bool
  };

  constructor(props) {
    super(props);
    this.state = {
      lastResolvedDate: props.woInformation.lastResolvedDate,
      lastClosedDate: props.woInformation.lastClosedDate,
      appointmentDate: props.woInformation.appointmentDate
        ? Moment(props.woInformation.appointmentDate)
        : null,
      defaultResolvedDate: props.woInformation.lastResolvedDate,
      defaultAppointmentDate: props.woInformation.appointmentDate,
      defaultClosedDate: props.woInformation.lastClosedDate,
      isModeAssignSub: props.woInformation.assignedUser ? false : true,
      subcontractor: props.woInformation.subcontractorProfile
        ? {
          value: props.woInformation.subcontractorProfile.subcontractorId,
          text: props.woInformation.subcontractorProfile.companyName,
          extensionValue: null,
          selected: false
        }
        : null,
      user: props.woInformation.assignedUser
        ? {
          value: props.woInformation.assignedUser.id,
          text: `${props.woInformation.assignedUser.displayName} (${
            props.woInformation.assignedUser.email
          })`,
          extensionValue: { email: props.woInformation.assignedUser.email },
          selected: false
        }
        : {
          value: props.requestDetail.managedByUser.id,
          text: `${props.requestDetail.managedByUser.displayName} (${
            props.requestDetail.managedByUser.email
          })`,
          extensionValue: { email: props.requestDetail.managedByUser.email },
          selected: false
        },
      defaultAssignee: props.woInformation.subcontractorProfile //eslint-disable-line
        ? props.woInformation.subcontractorProfile.subcontractorId //eslint-disable-line
        : props.woInformation.assignedUser
          ? props.woInformation.assignedUser.id
        : null, //eslint-disable-line
      isLoadingSubcontractor: false,
      isLoadingUser: false,
      resolvedDateError: null,
      closedDateError: null,
      appointmentDateError: null
    };
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.isEditResolved) {
      this.setState({
        defaultResolvedDate: nextProps.woInformation.lastResolvedDate,
        lastResolvedDate: nextProps.woInformation.lastResolvedDate
      });
    }
    if (nextProps.isEditClosed) {
      this.setState({
        defaultClosedDate: nextProps.woInformation.lastClosedDate,
        lastClosedDate: nextProps.woInformation.lastClosedDate
      });
    }
    if (nextProps.isEditAppointment) {
      this.setState({
        defaultAppointmentDate: nextProps.woInformation.appointmentDate,
        appointmentDate: nextProps.woInformation.appointmentDate
      });
    }
    if (nextProps.isEditReOpen) {
      this.setState({
        defaultAssignee: nextProps.woInformation.subcontractorProfile
          ? nextProps.woInformation.subcontractorProfile.subcontractorId
          : nextProps.woInformation.assignedUser.id
      });
    }

    if (nextProps.SubcontractorList) {
      this.setState({ isLoadingSubcontractor: false });
    }
    if (nextProps.UserList) {
      this.setState({ isLoadingUser: false });
    }
  }

  onResendNotice = () => {
    this.props.onResendNotice();
  };

  handleModeAssign = mode => {
    if (mode === 'sub') {
      this.setState(
        {
          isModeAssignSub: true
        },
        () => {
          if (!this.state.subcontractor) {
            this.setState({ errorMissingAssignedTo: true });
          } else {
            this.setState({ errorMissingAssignedTo: false });
          }
        }
      );
    } else {
      this.setState(
        {
          isModeAssignSub: false
        },
        () => {
          if (!this.state.user) {
            this.setState({ errorMissingAssignedTo: true });
          } else {
            this.setState({ errorMissingAssignedTo: false });
          }
        }
      );
    }
  };

  onSelectChange = (event, name) => {
    this.setState(
      {
        [name]: event.value
      },
      () => {
        if (
          (this.state.isModeAssignSub && !this.state.subcontractor) ||
          (!this.state.isModeAssignSub && !this.state.user)
        ) {
          this.setState({ errorMissingAssignedTo: true });
        } else {
          this.setState({ errorMissingAssignedTo: false });
        }
      }
    );
  };

  fetchSubcontractor = () => {
    if (!this.props.isFetchedSubcontractor) {
      this.setState({ isLoadingSubcontractor: true });
      this.props.fetchSubcontractor(this.props.woInformation.trade.id);
    }
  };

  fetchUser = () => {
    this.setState({ isLoadingUser: true });
    this.props.fetchUser();
  };

  handleCloseEditReOpen = () => {
    this.props.handleModeReOpen();
    this.setState({
      isModeAssignSub: this.props.woInformation.assignedUser ? false : true,
      subcontractor: this.props.woInformation.subcontractorProfile
        ? {
          value: this.props.woInformation.subcontractorProfile
            .subcontractorId,
          text: this.props.woInformation.subcontractorProfile.companyName,
          extensionValue: null,
          selected: false
        }
        : null,
      user: this.props.woInformation.assignedUser
        ? {
          value: this.props.woInformation.assignedUser.id,
          text: this.props.woInformation.assignedUser.displayName,
          extensionValue: {
            email: this.props.woInformation.assignedUser.email
          },
          selected: false
        }
        : {
          value: this.props.requestDetail.managedByUser.id,
          text: this.props.requestDetail.managedByUser.displayName,
          extensionValue: {
            email: this.props.requestDetail.managedByUser.email
          },
          selected: false
        },
      errorMissingAssignedTo: false
    });
  };

  handleSaveEditReOpen = () => {
    const data = this.state.isModeAssignSub
      ? {
        subcontractorId: this.state.subcontractor.value,
        assignedUserId: null
      }
      : {
        assignedUserId: this.state.user.value,
        subcontractorId: null
      };

    this.props.handleSaveEditReOpen(data);
    this.setState({ errorMissingAssignedTo: false });
  };

  onSelectTab = selectedKey => {
    this.props.history.push({
      pathname: this.props.location.pathname,
      search: `?active=${selectedKey}`
    });
  };

  renderAssignedTo = () => {
    const { woInformation } = this.props;
    if (woInformation.subcontractorProfile) {
      return this.renderWorkOrderValue(
        woInformation.subcontractorProfile.companyName
      );
    } else if (woInformation.assignedUser) {
      return this.renderWorkOrderValue(woInformation.assignedUser.displayName);
    } else {
      return this.renderWorkOrderValue(null);
    }
  };

  onChangeAppointmentDate = (appointmentDate) => {
    let currentDate = Moment(new Date());
    let currSelectedDate = Moment(appointmentDate._d);
    if (appointmentDate) {
      if (currentDate <= currSelectedDate) {
        if (Moment(appointmentDate, "MM/DD/YYYY hh:mm A", true).isValid()) {
          this.setState({
            appointmentDate,
            error: null,
          });
        } else {
          this.setState({
            error: "Invalid datetime.",
          });
        }
      } else {
        var selectedTime = Moment(
          appointmentDate._d,
          "MM/DD/YYYY hh:mm A"
        ).format("hh:mm A");
        this.setState({
          appointmentDate: Moment(appointmentDate._d).set({
            hour: Moment(selectedTime, "HH:mm").hour(),
            minute: Moment(selectedTime, "HH:mm").minute(),
          }),
          error: null,
        });
      }
    } else {
      this.setState({
        appointmentDate,
        error: null,
      });
    }
  };
  renderWorkOrderValue = (value) => {
    if (value) {
      return <strong>{value}</strong>;
    }
    return <span style={{ opacity: '.5' }}>(Not specified)</span>;
  };

  renderAppointmentValue = appointmentDate => {
    if (appointmentDate) {
      return <strong>{appointmentDate}</strong>;
    }
    return <span style={{ opacity: '.5' }}>(Not specified)</span>;
  };

  renderWorkOrderStatus = status => {
    const statusObject = AppSettings.WO_STATUS_VALUE.find((x) => x.key === status);
    console.log('statusObject', statusObject)
    return (
      <strong>
        {statusObject !== undefined && statusObject.value}
      </strong>
    );
  };

  renderAge = item => {
    // const day = item.age > 1 ? 'days' : 'day';
    const className = !item.overdue ? 'remaining-day-txt' : 'text-danger';
    return <strong className={className}>{item.age}</strong>;
  };

  renderInternalUserDropdown = () => {
    if (this.props.sso) {
      return (
        <Dropdown
          onChange={ref => {
            this.onSelectChange(ref, 'user');
          }}
          filter={true}
          className='filestring-dropdown filter-dropdown'
          onRemote={this.fetchUser}
          options={
            this.props.isFetchedUser
              ? this.props.UserList.map(item => {
                return {
                  ...item,
                  text: `${item.text} (${item.extensionValue.email})`
                };
              })
              : [{ ...this.state.user }]
          }
          loading={this.state.isLoadingUser}
          optionLabel='text'
          value={this.state.user}
          showClear={true}
          name='user'
          groupLabels={[
            {
              label: 'System users',
              field: 'sso',
              condition: [true]
            },
            {
              label: 'Builder users',
              field: 'sso',
              condition: [false, null]
            }
          ]}
          placeholder='--Select a user'
          style={{ width: '100%', paddingLeft: 15 }}
        />
      );
    }
    return (
      <Dropdown
        onChange={ref => {
          this.onSelectChange(ref, 'user');
        }}
        filter={true}
        className='filestring-dropdown filter-dropdown'
        onRemote={this.fetchUser}
        options={
          this.props.isFetchedUser
            ? this.props.UserList.map(item => {
              return {
                ...item,
                text: `${item.text} (${item.extensionValue.email})`
              };
            })
            : [{ ...this.state.user }]
        }
        loading={this.state.isLoadingUser}
        optionLabel='text'
        value={this.state.user}
        showClear={true}
        name='user'
        placeholder='--Select a user'
        style={{ width: '100%', paddingLeft: 15 }}
      />
    );
  };

  renderWorkOrderGeneralInformation = () => {
    const { woInformation, isPunchItem } = this.props;
    const disabledSaveEditClosed =
      Moment(this.state.lastClosedDate).format('MM/DD/YYYY') ===
        Moment(this.state.defaultClosedDate).format('MM/DD/YYYY') ||
      !this.state.lastClosedDate;
    const disabledSaveEditResolved =
      Moment(this.state.lastResolvedDate).format('MM/DD/YYYY') ===
        Moment(this.state.defaultResolvedDate).format('MM/DD/YYYY') ||
      !this.state.lastResolvedDate;
    const disabledSaveEditAppointment =
      Moment(this.state.appointmentDate).format('MM/DD/YYYY hh/mm A') ===
        Moment(this.state.defaultAppointmentDate).format('MM/DD/YYYY hh/mm A');
    return (
      <div>
        <div className='row'>
          <div className='form-group'>
            <label className='col-sm-3 control-label'>Status</label>
            <div className='col-sm-9 control-label name form-text-label'>
              {this.renderWorkOrderStatus(woInformation.status)}
              {/* 2 === pending */}
              {woInformation.status === 2 && woInformation.holdReason && (
                <OverlayReason reason={woInformation.holdReason} />
              )}
              {/* 3 === declined*/}
              {woInformation.status === 3 && woInformation.declinedReason && (
                <OverlayReason reason={woInformation.declinedReason} />
              )}
              {/* 3 === reOpen*/}
              {woInformation.status === 6 && woInformation.reopenReason && (
                <OverlayReason reason={woInformation.reopenReason} />
              )}
              {/* 5 === Closed*/}
              {woInformation.status === 5 && woInformation.closedReason && (
                <OverlayReason reason={woInformation.closedReason} />
              )}
            </div>
          </div>
        </div>

        <div className='row'>
          <div className='form-group'>
            <label className='col-sm-3 control-label'>Created</label>
            <div className='col-sm-9 control-label name form-text-label'>
              {this.renderWorkOrderValue(
                woInformation.createdDate
                  ? Moment(woInformation.createdDate).format('MM/DD/YYYY')
                  : null
              )}
            </div>
          </div>
        </div>

        {woInformation.status === 1 && (
          <React.Fragment>
            <div className='row'>
              <div className='form-group'>
                <label className='col-sm-3 control-label'>Total age</label>
                <div className='col-sm-9 control-label name form-text-label'>
                  <strong>{woInformation.totalAge}</strong>
                </div>
              </div>
            </div>

            <div className='row'>
              <div className='form-group'>
                <label className='col-sm-3 control-label'>
                  Age of assignment
                </label>
                <div className='col-sm-9 control-label name form-text-label'>
                  {this.renderAge(woInformation)}
                </div>
              </div>
            </div>
          </React.Fragment>
        )}

        {!isPunchItem && (
          <div className='row'>
            <div className='form-group'>
              <label className='col-sm-3 control-label'>Work order type</label>
              <div className='col-sm-9 control-label name form-text-label'>
                {this.renderWorkOrderValue(
                  woInformation.workOrderType
                    ? woInformation.workOrderType.name
                    : null
                )}
              </div>
            </div>
          </div>
        )}

        <div className='row'>
          <div className='form-group'>
            <label className='col-sm-3 control-label'>Location</label>
            <div className='col-sm-9 control-label name form-text-label'>
              {this.renderWorkOrderValue(
                woInformation.room ? woInformation.room.name : null
              )}
            </div>
          </div>
        </div>

        <div className='row'>
          <div className='form-group'>
            <label className='col-sm-3 control-label'>Trade</label>
            <div className='col-sm-9 control-label name form-text-label'>
              {this.renderWorkOrderValue(
                woInformation.trade ? woInformation.trade.name : null
              )}
            </div>
          </div>
        </div>

        <div className='row'>
          {this.props.isEditReOpen ? (
            <div className='form-group'>
              <div
                className='col-sm-12 control-label form-siteone-label'
                style={{ paddingLeft: 15, paddingBottom: 10 }}
              >
                Assigned to <span className='text-danger'>*</span>
                <div
                  className='btn-group btn-group-sm wo-assign-btn-group'
                  role='group'
                >
                  <button
                    type='button'
                    className={
                      'btn btn-secondary ' +
                      (this.state.isModeAssignSub ? 'active' : '')
                    }
                    onClick={() => {
                      this.handleModeAssign('sub');
                    }}
                  >
                    subcontractor
                  </button>
                  <button
                    type='button'
                    className={
                      'btn btn-secondary ' +
                      (!this.state.isModeAssignSub ? 'active' : '')
                    }
                    onClick={() => {
                      this.handleModeAssign('user');
                    }}
                  >
                    internal user
                  </button>
                </div>
              </div>
              <div className='col-sm-6' style={{ paddingLeft: 0 }}>
                {this.state.isModeAssignSub ? (
                  <Dropdown
                    onChange={ref => {
                      this.onSelectChange(ref, 'subcontractor');
                    }}
                    filter={true}
                    className='filestring-dropdown filter-dropdown'
                    onRemote={this.fetchSubcontractor}
                    options={
                      this.props.isFetchedSubcontractor
                        ? this.props.SubcontractorList
                        : [{ ...this.state.subcontractor }]
                    }
                    optionLabel='text'
                    value={this.state.subcontractor}
                    loading={this.state.isLoadingSubcontractor}
                    showClear={true}
                    name='subcontractor'
                    placeholder='--Select a trade first'
                    style={{ width: '100%', paddingLeft: 15 }}
                  />
                ) : (
                  this.renderInternalUserDropdown()
                )}
              </div>
              {this.state.errorMissingAssignedTo && (
                <span
                  className='col-sm-12 text-danger'
                  style={{ fontSize: 12, marginTop: -20, marginBottom: 15 }}
                >
                  This field is required.
                </span>
              )}
            </div>
          ) : (
            <div className='form-group'>
              <label className='col-sm-3 control-label'>Assigned to</label>
              <div className='col-sm-9 control-label name form-text-label'>
                {this.renderAssignedTo()}
                {woInformation.status === 1 &&
                  AppSettings.clientTypeValue === 'Builder' && (
                    <span style={{ marginLeft: 15 }}>
                      <Link to={'#'} onClick={this.onResendNotice}>
                        Resend notice
                      </Link>
                    </span>
                  )}
              </div>
            </div>
          )}
        </div>

        <div className='row'>
          <div className='form-group'>
            <label className='col-sm-3 control-label'>Item to repair</label>
            <div className='col-sm-9 control-label name form-text-label text-pre-wrap'>
              {this.renderWorkOrderValue(
                woInformation.itemToRepair
                  ? woInformation.itemToRepair.description
                  : null
              )}
            </div>
          </div>
        </div>

        <div className='row'>
          <div className='form-group'>
            <label className='col-sm-3 control-label'>Problem</label>
            <div className='col-sm-9 control-label name form-text-label'>
              {this.renderWorkOrderValue(
                woInformation.problem ? woInformation.problem.name : null
              )}
            </div>
          </div>
        </div>

        {!isPunchItem && <br />}

        <div className='row'>
          <div className='form-group'>
            <label className='col-sm-3 control-label'>Summary</label>
            <div className='col-sm-9 control-label name form-text-label'>
              {this.renderWorkOrderValue(woInformation.title)}
            </div>
          </div>
        </div>

        <div className='row'>
          <div className='form-group'>
            <label className='col-sm-3 control-label'>Description</label>
            <div className='col-sm-9 control-label name form-text-label text-pre-wrap'>
              {this.renderWorkOrderValue(
                woInformation.description ? woInformation.description : null
              )}
            </div>
          </div>
        </div>

        {/* <div className='row'>
          <div className='form-group'>
            <label className='col-sm-3 control-label'>Appointment</label>
            <div className='col-sm-9 control-label name form-text-label'>
              {this.renderWorkOrderValue(
                woInformation.appointmentDate
                  ? Moment(woInformation.appointmentDate).format(
                    'MM/DD/YYYY hh:mm A'
                  )
                  : null
              )}
            </div>
          </div>
        </div> */}

        {woInformation.lastResolvedDate && (
          <div className='row'>
            {!this.props.isEditResolved ? (
              <div className='form-group'>
                <label className='col-sm-3 control-label'>Last resolved</label>
                <div className='col-sm-9 control-label name form-text-label'>
                  {this.renderWorkOrderValue(
                    woInformation.lastResolvedDate
                      ? Moment(woInformation.lastResolvedDate).format(
                        'MM/DD/YYYY'
                      )
                      : null
                  )}
                </div>
              </div>
            ) : (
              <div className='form-group'>
                <label className='col-sm-12 control-label'>
                  Last resolved <span className='text-danger'>*</span>
                </label>
                <div
                  className='col-sm-6 control-label name form-text-label'
                  style={{ paddingLeft: 15 }}
                >
                  <Datetime
                    ref={ref => {
                      this.lastResolvedDate = ref;
                    }}
                    name='lastResolvedDate'
                    inputProps={{ placeholder: 'mm/dd/yyyy' }}
                    timeFormat={false}
                    defaultValue={Moment(woInformation.lastResolvedDate)}
                    onChange={lastResolvedDate => {
                      if (!lastResolvedDate) {
                        this.setState({
                          resolvedDateError: 'This field is required.'
                        });
                      } else if (
                        Moment(
                          lastResolvedDate,
                          'MM/DD/YYYY',
                          true
                        ).isValid() ||
                        lastResolvedDate === ''
                      ) {
                        this.setState({
                          lastResolvedDate,
                          resolvedDateError: null
                        });
                      } else {
                        this.setState({
                          resolvedDateError: 'Invalid datetime.'
                        });
                      }
                    }}
                    closeOnSelect={true}  />
                  {this.state.resolvedDateError && (
                    <span
                      className='text-danger col-sm-12'
                      style={{ fontSize: 12, marginTop: 5, padding: 0 }}
                    >
                      {this.state.resolvedDateError}
                    </span>
                  )}
                </div>
              </div>
            )}
          </div>
        )}

        {woInformation.lastClosedDate && (
          <div className='row'>
            {!this.props.isEditClosed ? (
              <div className='form-group'>
                <label className='col-sm-3 control-label'>Last closed</label>
                <div className='col-sm-9 control-label name form-text-label'>
                  <strong>
                    {this.renderWorkOrderValue(
                      woInformation.lastClosedDate
                        ? Moment(woInformation.lastClosedDate).format(
                          'MM/DD/YYYY'
                        )
                        : null
                    )}
                  </strong>
                </div>
              </div>
            ) : (
              <div className='form-group'>
                <label className='col-sm-12 control-label'>
                  Last closed <span className='text-danger'>*</span>
                </label>
                <div
                  className='col-sm-6 control-label name form-text-label'
                  style={{ paddingLeft: 15 }}
                >
                  <Datetime
                    ref={ref => {
                      this.lastClosedDate = ref;
                    }}
                    name='lastClosedDate'
                    inputProps={{ placeholder: 'mm/dd/yyyy' }}
                    timeFormat={false}
                    defaultValue={Moment(woInformation.lastClosedDate)}
                    onChange={lastClosedDate => {
                      if (!lastClosedDate) {
                        this.setState({
                          closedDateError: 'This field is required.'
                        });
                      } else if (
                        Moment(lastClosedDate, 'MM/DD/YYYY', true).isValid() ||
                        lastClosedDate === ''
                      ) {
                        this.setState({
                          lastClosedDate,
                          closedDateError: null
                        });
                      } else {
                        this.setState({ closedDateError: 'Invalid datetime.' });
                      }
                    }}
                    closeOnSelect={true}  />
                  {this.state.closedDateError && (
                    <span
                      className='text-danger col-sm-12'
                      style={{ fontSize: 12, marginTop: 5, padding: 0 }}
                    >
                      {this.state.closedDateError}
                    </span>
                  )}
                </div>
              </div>
            )}
          </div>
        )}

        {/* Edit AppointmentDate in Subcontractor */}
        {
          <div className='row'>
            {!this.props.isEditAppointment ? (
              <div className='form-group'>
                <label className='col-sm-3 control-label'>Appointment</label>
                <div className='col-sm-9 control-label name form-text-label'>
                  {this.renderAppointmentValue(
                    woInformation.appointmentDate
                      ? Moment(woInformation.appointmentDate).format(
                        'MM/DD/YYYY hh:mm A'
                      )
                      : null
                  )}
                </div>
              </div>
            ) : (
              <div className='form-group'>
                <label className='col-sm-12 control-label'>
                Appointment
                </label>
                <div
                  className='col-sm-6 control-label name form-text-label'
                  style={{ paddingLeft: 15 }}
                >
                  <Datetime
                  ref={ref => { this.appointmentDate = ref; }}
                  name='appointmentDate'
                  initialViewDate={woInformation.appointmentDate?Moment(woInformation.appointmentDate)
                    :Moment(new Date()).set({ hour: 9, minute: 0 })}
                  inputProps={{ placeholder: 'mm/dd/yyyy hh:mm' }}
                  value={this.state.appointmentDate? Moment(this.state.appointmentDate).format(
                    'MM/DD/YYYY hh:mm A'
                  )
                  : null}
                  onChange={this.onChangeAppointmentDate} 
                  closeOnSelect={true}
                  isValidDate={isValidAppointmentDate}
                />
                  {this.state.appointmentDateError && (
                    <span
                      className='text-danger col-sm-12'
                      style={{ fontSize: 12, marginTop: 5, padding: 0 }}
                    >
                      {this.state.appointmentDateError}
                    </span>
                  )}
                </div>
              </div>
            )}
          </div>
        }

        {/* Button Group Edit Resolved Work Order */}
        {this.props.isEditResolved && (
          <ul className='wo-detail-bottom-btn'>
            <li>
              <button
                className='btn btn-primary btn-siteone-default btn-wo-edit'
                onClick={() => {
                  this.setState(
                    { resolvedDateError: null, closedDateError: null },
                    () => {
                      this.props.handleModeResolved();
                    }
                  );
                }}
              >
                Cancel
              </button>
            </li>
            <li>
              <button
                className='btn btn-primary btn-submit btn-siteone'
                disabled={
                  disabledSaveEditResolved || this.state.resolvedDateError
                }
                onClick={() =>
                  this.props.handleSaveEditResolved(this.state.lastResolvedDate)
                }
              >
                Save
              </button>
            </li>
          </ul>
        )}
        {/* Button Group Edit Open Work Order in Subcontractor  */}
        {this.props.isEditAppointment && (
          <ul className='wo-detail-bottom-btn'>
            <li>
              <button
                className='btn btn-primary btn-siteone-default btn-wo-edit'
                onClick={() => {
                  this.setState(
                    { appointmentDateError: null },
                    () => {
                      this.props.handleModeOpenSubcontractor();
                    }
                  );
                }}
              >
                Cancel
              </button>
            </li>
            <li>
              <button
                className='btn btn-primary btn-submit btn-siteone'
                disabled={disabledSaveEditAppointment || this.state.appointmentDateError}
                onClick={() =>
                  this.props.handleSaveEditAppointment(this.state.appointmentDate)
                }
              >
                Save
              </button>
            </li>
          </ul>
        )}

        {/* Button Group Edit Closed Work Order */}
        {this.props.isEditClosed && (
          <ul className='wo-detail-bottom-btn'>
            <li>
              <button
                className='btn btn-primary btn-siteone-default btn-wo-edit'
                onClick={() => {
                  this.setState(
                    { resolvedDateError: null, closedDateError: null },
                    () => {
                      this.props.handleModeClosed();
                    }
                  );
                }}
              >
                Cancel
              </button>
            </li>
            <li>
              <button
                className='btn btn-primary btn-submit btn-siteone'
                disabled={disabledSaveEditClosed || this.state.closedDateError}
                onClick={() =>
                  this.props.handleSaveEditClosed(this.state.lastClosedDate)
                }
              >
                Save
              </button>
            </li>
          </ul>
        )}

        {/* Button Group Edit Closed Work Order */}
        {this.props.isEditReOpen && (
          <ul className='wo-detail-bottom-btn'>
            <li>
              <button
                className='btn btn-primary btn-siteone-default btn-wo-edit'
                onClick={() => {
                  this.setState(
                    { resolvedDateError: null, closedDateError: null },
                    () => {
                      this.handleCloseEditReOpen();
                    }
                  );
                }}
              >
                Cancel
              </button>
            </li>
            <li>
              <button
                className='btn btn-primary btn-submit btn-siteone'
                disabled={
                  (this.state.isModeAssignSub && !this.state.subcontractor) ||
                  (!this.state.isModeAssignSub && !this.state.user) ||
                  (this.state.isModeAssignSub &&
                    this.state.subcontractor.value ===
                      this.state.defaultAssignee) ||
                  (!this.state.isModeAssignSub &&
                    this.state.user.value === this.state.defaultAssignee)
                }
                onClick={this.handleSaveEditReOpen}
              >
                Save
              </button>
            </li>
          </ul>
        )}
      </div>
    );
  };

  render() {
    return <div>{this.renderWorkOrderGeneralInformation()}</div>;
  }
}

export default WorkOrderInfo;



// WEBPACK FOOTER //
// ./src/Work-Orders/Components/WorkOrderInfo.js